export enum RequestsWsEvents {
  GetRequests = 'get_requests'
}
